import { useSelector } from "react-redux";

import { enumeratedDataValuesSlice } from "redux/features/enumeratedDataValues";

export function useOccupationLookup() {
  const enumeratedDataValues = useSelector(enumeratedDataValuesSlice.selector);
  const occupations = enumeratedDataValues.data.occupations;
  const occupationLookup = Object.fromEntries(
    occupations.map((o) => [o.id, o])
  );
  return occupationLookup;
}

function useOccupationDetail(id) {
  const enumeratedDataValues = useSelector(enumeratedDataValuesSlice.selector);
  const occupations = enumeratedDataValues.data.occupations;
  const occupationLookup = Object.fromEntries(
    occupations.map((o) => [o.id, o])
  );
  const occupationSymbolicLookup = Object.fromEntries(
    occupations.map((o) => [o.symbolic_id, o])
  );

  const occupation = id !== null ? occupationLookup[id] : null;
  let mappedOccupation = occupation;
  if (occupation && occupation.tags.includes("LEGACY")) {
    const replacements = [...occupation.tags, "OTHER"]
      .map((tag) => occupationSymbolicLookup[tag])
      .filter((o) => o && !o.tags.includes("LEGACY"));
    mappedOccupation = replacements[0];
  }

  const optionId = mappedOccupation ? mappedOccupation.id : "";

  const promptOptions = occupations.filter((o) => !o.tags.includes("LEGACY"));

  const demographicsNeeded = mappedOccupation
    ? {
        phdOrFacultyYear:
          mappedOccupation.symbolic_id === "FACULTY" ||
          mappedOccupation.symbolic_id === "POSTDOCTORAL_FELLOW",
        phdYear: mappedOccupation.symbolic_id === "POSTDOCTORAL_FELLOW",
      }
    : {};

  const noInstitution =
    !mappedOccupation || mappedOccupation.tags.includes("NO_INSTITUTION");
  const optionalInstitution =
    mappedOccupation && mappedOccupation.tags.includes("OPTIONAL_INSTITUTION");

  const institutionQuestion = noInstitution
    ? null
    : optionalInstitution
    ? mappedOccupation.symbolic_id === "RETIRED"
      ? `If you still wish to be listed as affiliated with the
company/organization you have retired from, you may provide it here:`
      : mappedOccupation.symbolic_id === "SCHOOL"
      ? `(Optional) Name of school, if you wish to provide it`
      : `(Optional) Name of institution, if you wish to provide it`
    : mappedOccupation.tags.includes("SCHOOL")
    ? "At which school (or school board)?"
    : mappedOccupation.tags.includes("CORPORATE")
    ? "At which company/organization/institution?"
    : mappedOccupation.tags.includes("GOVERNMENT")
    ? "At which agency/organization/institution?"
    : "At which institution(s)?";

  return {
    occupation,
    mappedOccupation,
    remapped: occupation && occupation !== mappedOccupation,
    optionId,
    promptOptions,
    demographicsNeeded,
    institutionQuestion,
    noInstitution,
    optionalInstitution,
  };
}

export default useOccupationDetail;
